<template>
  <div></div>
</template>

<script>
export default {
  name: "PageView",
};
</script>

<style scoped></style>
